/* Wandercat – Custom Produktgalerie + Sticky-Mobile-CTA für die Lifetime-Produktseite. */
(() => {
  if (customElements.get('wc-product-gallery')) return;

  customElements.define(
    'wc-product-gallery',
    class WcProductGallery extends HTMLElement {
      connectedCallback() {
        this.viewer = this.querySelector('.wc-plg__viewer');
        this.thumbsEl = this.querySelector('.wc-plg__thumbs');
        this.dotsEl = this.querySelector('.wc-plg__dots');
        this.slides = Array.from(this.querySelectorAll('.wc-plg__slide'));
        if (!this.viewer || !this.slides.length) return;

        this.mql = window.matchMedia('(min-width: 750px)');
        this.activeIndex = Math.max(
          this.slides.findIndex((slide) => slide.classList.contains('is-active')),
          0
        );

        this.buildThumbs();
        this.buildDots();
        this.applyRatio(this.slides[this.activeIndex]);
        this.bindSlideClicks();
        this.bindMobileScroll();

        window.addEventListener('resize', () => this.applyRatio(this.slides[this.activeIndex]));
      }

      buildThumbs() {
        if (!this.thumbsEl) return;
        this.slides.forEach((slide, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'wc-plg__thumb';
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-label', slide.dataset.label || '');
          button.setAttribute('aria-current', String(index === this.activeIndex));
          button.dataset.index = String(index);

          const img = document.createElement('img');
          img.src = slide.dataset.thumb;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 120;
          img.height = 120;
          button.appendChild(img);

          if (slide.dataset.type === 'video') {
            const badge = document.createElement('span');
            badge.className = 'wc-plg__thumb-badge';
            badge.setAttribute('aria-hidden', 'true');
            badge.innerHTML = this.playIconMarkup();
            button.appendChild(badge);
          }

          button.addEventListener('click', () => {
            const autoplay = slide.dataset.type === 'video';
            this.setActive(index, { autoplay, scroll: true });
          });

          this.thumbsEl.appendChild(button);
        });
      }

      buildDots() {
        if (!this.dotsEl || this.slides.length < 2) return;
        this.slides.forEach((slide, index) => {
          const dot = document.createElement('span');
          dot.className = 'wc-plg__dot';
          dot.setAttribute('aria-current', String(index === this.activeIndex));
          this.dotsEl.appendChild(dot);
        });
      }

      playIconMarkup() {
        return '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 14" width="10" height="14"><path fill="currentColor" fill-rule="evenodd" d="M1.482.815A1 1 0 0 0 0 1.69v10.517a1 1 0 0 0 1.525.851L10.54 7.5a1 1 0 0 0-.043-1.728z" clip-rule="evenodd"/></svg>';
      }

      bindSlideClicks() {
        this.slides.forEach((slide) => {
          if (slide.dataset.type !== 'video') return;
          const video = slide.querySelector('video');
          const playButton = slide.querySelector('.wc-plg__play');
          const start = () => {
            slide.classList.add('is-playing');
            video.play().catch(() => {});
          };
          playButton.addEventListener('click', start);
          video.addEventListener('click', () => {
            if (video.paused) start();
            else video.pause();
          });
          video.addEventListener('pause', () => slide.classList.remove('is-playing'));
          video.addEventListener('play', () => slide.classList.add('is-playing'));
        });
      }

      bindMobileScroll() {
        let ticking = false;
        this.viewer.addEventListener(
          'scroll',
          () => {
            if (this.mql.matches || ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
              const index = Math.round(this.viewer.scrollLeft / this.viewer.clientWidth);
              if (index !== this.activeIndex && this.slides[index]) {
                this.setActive(index, { autoplay: false, scroll: false });
              }
              ticking = false;
            });
          },
          { passive: true }
        );
      }

      applyRatio(slide) {
        if (!slide) return;
        this.viewer.style.setProperty('--wc-plg-ratio', slide.dataset.ratio || '1');
      }

      pauseAllVideos() {
        this.slides.forEach((slide) => {
          const video = slide.querySelector('video');
          if (video && !video.paused) video.pause();
        });
      }

      setActive(index, { autoplay = false, scroll = false } = {}) {
        const slide = this.slides[index];
        if (!slide) return;

        this.pauseAllVideos();

        this.slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
        this.applyRatio(slide);

        if (this.thumbsEl) {
          Array.from(this.thumbsEl.children).forEach((button, i) => {
            button.setAttribute('aria-current', String(i === index));
          });
          const activeThumb = this.thumbsEl.children[index];
          if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
            activeThumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
          }
        }

        if (this.dotsEl) {
          Array.from(this.dotsEl.children).forEach((dot, i) => {
            dot.setAttribute('aria-current', String(i === index));
          });
        }

        if (scroll && !this.mql.matches) {
          this.viewer.scrollTo({ left: index * this.viewer.clientWidth, behavior: 'smooth' });
        }

        this.activeIndex = index;

        if (autoplay && slide.dataset.type === 'video') {
          const video = slide.querySelector('video');
          if (video) video.play().catch(() => {});
        }
      }
    }
  );
})();

/* --- Sticky Mobile-CTA (Kauf-Leiste) ---------------------------------- */
(() => {
  const bar = document.querySelector('[data-wc-lifetime-sticky-cta]');
  if (!bar || typeof IntersectionObserver === 'undefined') return;

  const targetId = bar.dataset.wcLifetimeStickyCta;
  const target = targetId ? document.getElementById(targetId) : null;
  if (!target) return;

  const sync = (entry) => {
    const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    bar.classList.toggle('is-visible', show);
  };

  new IntersectionObserver(([entry]) => sync(entry), { threshold: 0 }).observe(target);
})();
